// src/components/PinisiKata/PinisiShipSVG.js
import React from 'react';

function PinisiShipSVG({ className }) {
    // Palet warna yang sama persis dengan gambar referensi
    const colors = {
        hullRed: '#C0392B',
        deckOrange: '#E59866',
        superstructureCream: '#F5EEF8',
        bumperBlue: '#2C3E50',
        windowBlue: '#5DADE2',
        funnelTan: '#D5BBA9',
        funnelStripe: '#C3A997',
        lifebuoyWhite: '#FFFFFF',
        lifebuoyRed: '#E74C3C',
        ropeBlack: '#212121',
    };

    return (
        <svg viewBox="0 0 400 300" className={className} xmlns="http://www.w3.org/2000/svg">
            <defs>
                {/* Definisi satu pelampung untuk digunakan kembali */}
                <g id="lifebuoy" stroke={colors.ropeBlack} strokeWidth="1.5">
                    <circle cx="0" cy="0" r="12" fill={colors.lifebuoyWhite} />
                    <path d="M 0 -12 A 12 12 0 0 1 8.5 -8.5 L 6 -6 A 8 8 0 0 0 0 -8 Z" fill={colors.lifebuoyRed} stroke="none" />
                    <path d="M 12 0 A 12 12 0 0 1 8.5 8.5 L 6 6 A 8 8 0 0 0 8 0 Z" fill={colors.lifebuoyRed} stroke="none" />
                    <path d="M 0 12 A 12 12 0 0 1 -8.5 8.5 L -6 6 A 8 8 0 0 0 0 8 Z" fill={colors.lifebuoyRed} stroke="none" />
                    <path d="M -12 0 A 12 12 0 0 1 -8.5 -8.5 L -6 -6 A 8 8 0 0 0 -8 0 Z" fill={colors.lifebuoyRed} stroke="none" />
                </g>
            </defs>

            <g transform="translate(0, 30)">
                {/* Lambung Merah Utama */}
                <path
                    d="M 50 200 C 50 250, 320 250, 350 200 L 370 140 L 60 140 Z"
                    fill={colors.hullRed}
                />
                
                {/* Bumper Biru di Haluan */}
                <path 
                    d="M 55 140 C 30 140, 30 200, 55 200 Z"
                    fill={colors.bumperBlue}
                />
                <rect x="42" y="155" width="8" height="15" fill="#566573" rx="2" />
                <rect x="42" y="175" width="8" height="15" fill="#566573" rx="2" />

                {/* Dek Oranye */}
                <path
                    d="M 60 140 L 370 140 L 365 130 L 65 130 Z"
                    fill={colors.deckOrange}
                />
                
                {/* Detail di lambung */}
                <circle cx="300" cy="155" r="5" fill="#D98880" />
                <circle cx="320" cy="155" r="5" fill="#D98880" />
                <circle cx="340" cy="155" r="5" fill="#D98880" />
                
                {/* Struktur Kabin (Superstructure) */}
                <path 
                    d="M 130 130 L 280 130 L 280 80 L 140 80 C 135 80, 130 85, 130 90 Z"
                    fill={colors.superstructureCream}
                />
                <rect x="200" y="70" width="80" height="10" fill={colors.deckOrange} />
                <rect x="230" y="60" width="60" height="10" fill={colors.superstructureCream} />

                {/* Jendela Biru */}
                <path 
                    d="M 150 115 L 150 95 C 150 90, 170 90, 170 95 L 170 115 Z"
                    fill={colors.windowBlue}
                />

                {/* Cerobong Asap */}
                <rect x="180" y="20" width="20" height="80" fill={colors.funnelTan} />
                <rect x="175" y="15" width="30" height="5" fill={colors.funnelStripe} rx="2"/>
                <rect x="178" y="70" width="24" height="5" fill={colors.funnelStripe} rx="2"/>
                <rect x="178" y="50" width="24" height="5" fill={colors.funnelStripe} rx="2"/>

                {/* Pagar dan Tali */}
                <g stroke={colors.ropeBlack} strokeWidth="2">
                    {/* Tiang Pagar */}
                    <path d="M 70 130 L 70 120 M 365 130 L 365 120" fill="none" />
                    {/* Tali Hitam */}
                    <path 
                        d="M 70 120 C 100 140, 120 140, 150 120 C 180 100, 200 100, 230 120 C 260 140, 280 140, 310 120 C 340 100, 350 100, 365 120"
                        fill="none"
                    />
                </g>

                {/* Pelampung (Lifebuoys) */}
                <use href="#lifebuoy" transform="translate(105, 125)" />
                <use href="#lifebuoy" transform="translate(175, 110)" />
                <use href="#lifebuoy" transform="translate(265, 125)" />
                <use href="#lifebuoy" transform="translate(335, 110)" />
                <use href="#lifebuoy" transform="translate(250, 100) scale(0.7)" />


                {/* Tiang Bendera */}
                <g>
                    <rect x="90" y="70" width="4" height="60" fill={colors.bumperBlue} />
                    <rect x="85" y="80" width="25" height="15" fill={colors.hullRed} />
                    <circle cx="92" cy="70" r="4" fill={colors.bumperBlue} />
                </g>
            </g>
        </svg>
    );
}

export default PinisiShipSVG;